/** Theme providers can set this inherited property to colour the knockout in filled icons. */
export const ICON_KNOCKOUT_COLOR_PROPERTY = '--omnea-icon-knockout-color'
